<script setup>
</script>
<template>
    <section class="gift section">
        <div class="container">
            <h2 class="gift__title title2" data-animation-left>ПРИОБРЕТАЯ СЕРТИФИКАТ <span class="title-border">The Rink Fitness</span> вы&nbsp;дарите:</h2>
            <div class="gift__container">
                <div class="gift__logo">
                    <img class='' width='190' height='597' src='@/assets/img/icons/gift_logo.svg' alt='изображение логотипа'>
                </div>
                <ul class="gift__list" data-animation-right>
                    <li>ДОСТУП К ПРОФЕССИОНАЛЬНЫМ ФИТНЕС-ЗОНАМ С ОБОРУДОВАНИЕМ ПРЕМИУМ-КЛАССА</li>
                    <li>ЭКСПЕРТНУЮ ПОМОЩЬ ОПЫТНЫХ ТРЕНЕРОВ РАЗНЫХ НАПРАВЛЕНИЙ</li>
                    <li>УДОВОЛЬСТВИЕ ОТ ОБЩЕНИЯ С ЕДИНОМЫШЛЕННИКАМИ, ДАЮЩЕЕ КРУГОЗОР И МОТИВАЦИЮ</li>
                    <li>ВОЗМОЖНОСТЬ ОТКРЫТЬ ДЛЯ СЕБЯ НОВЫЕ ВИДЫ СПОРТА И УВЛЕЧЕНИЯ</li>
                    <li>ЖИВОПИСНОЕ OUTDOOR ПРОСТРАНСТВО ДЛЯ ОТДЫХА И ВОССТАНОВЛЕНИЯ, ВКЛЮЧАЯ ЛАУНДЖ-ЗОНУ THE SUN CLUB</li>
                </ul>
            </div>
        </div>
    </section>    
</template>
<style lang='scss' scoped>
</style>